(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('QuestionnaireGroupDetailController', QuestionnaireGroupDetailController);

    QuestionnaireGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'QuestionnaireGroup', 'Company'];

    function QuestionnaireGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, QuestionnaireGroup, Company) {
        var vm = this;

        vm.questionnaireGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:questionnaireGroupUpdate', function(event, result) {
            vm.questionnaireGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
